/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Sign_InInputs */

const en_auth_sign_in = /** @type {(inputs: Auth_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign In`)
};

const es_auth_sign_in = /** @type {(inputs: Auth_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciar sesión`)
};

const fr_auth_sign_in = /** @type {(inputs: Auth_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se connecter`)
};

const de_auth_sign_in = /** @type {(inputs: Auth_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anmelden`)
};

const ja_auth_sign_in = /** @type {(inputs: Auth_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ログイン`)
};

const zh_auth_sign_in = /** @type {(inputs: Auth_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登录`)
};

const ar_auth_sign_in = /** @type {(inputs: Auth_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تسجيل الدخول`)
};

const id_auth_sign_in = /** @type {(inputs: Auth_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masuk`)
};

const it_auth_sign_in = /** @type {(inputs: Auth_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accedi`)
};

const ru_auth_sign_in = /** @type {(inputs: Auth_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Войти`)
};

const pt_auth_sign_in = /** @type {(inputs: Auth_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrar`)
};

const ko_auth_sign_in = /** @type {(inputs: Auth_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`로그인`)
};

/**
* | output |
* | --- |
* | "Sign In" |
*
* @param {Auth_Sign_InInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const auth_sign_in = /** @type {((inputs?: Auth_Sign_InInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Sign_InInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_sign_in(inputs)
	if (locale === "es") return es_auth_sign_in(inputs)
	if (locale === "fr") return fr_auth_sign_in(inputs)
	if (locale === "de") return de_auth_sign_in(inputs)
	if (locale === "ja") return ja_auth_sign_in(inputs)
	if (locale === "zh") return zh_auth_sign_in(inputs)
	if (locale === "ar") return ar_auth_sign_in(inputs)
	if (locale === "id") return id_auth_sign_in(inputs)
	if (locale === "it") return it_auth_sign_in(inputs)
	if (locale === "ru") return ru_auth_sign_in(inputs)
	if (locale === "pt") return pt_auth_sign_in(inputs)
	return ko_auth_sign_in(inputs)
});